import styled from 'styled-components';
import { Column } from '@prisjakt/ui/list/variants';
import Button from '@prisjakt/ui-button';

export const FlexColumn = styled(Column)`
  flex: 0 1 auto;
`;

export const CallToActionButton = styled(Button).attrs({
  color: 'primary',
  variant: 'outlined',
})`
  color: ${p => p.theme.text.callToAction};
`;
